module.exports = __webpack_public_path__ + "img/bsg_model_ad.00009ffc.png";